<template>
    <div>
        <main-navigation/>

        <centered-card headline="Sync your tumblr-blogs">


            <step-indicator :steps="4" :step="currentStep"/>


            <div v-if="tumblrAuthUrl">
                <h2>1. connect with tumblr</h2>
                <p></p>
                <p>
                    <a :href="tumblrAuthUrl" class="btn btn-primary">Login</a>
                </p>
            </div>
            <loading-indicator name="user.tumblr.getAuth"/>

            <loading-indicator name="user.tumblr.verifyAuth"/>

            <div v-if="blogs.length">
                <h2>2. Select your tumblr-blogs</h2>
                <p>Please select all the blogs, you want to import or sync.</p>

                <transition-group name="bloglist" tag="div">
                    <div v-for="blog in blogList"
                         class="media blog"
                         :class="{selected:blog.selected}"
                         @click="blog.selected=!blog.selected"
                         :key="blog.name"
                    >
                        <img class="mr-3" :src="getBlogAvatar(blog)" alt="Generic placeholder image">
                        <div class="media-body">
                            <h4 class="mt-3">{{blog.name}}</h4>
                            <p>{{ blog.info }}</p>
                        </div>
                    </div>
                </transition-group>

                <div v-if="!importing" class="mt-3 text-center">
                    <button class="btn btn-lg btn-outline-primary" @click="startImport()">Import selected Blogs</button>
                </div>

            </div>

            <loading-indicator name="user.tumblr.getUserInfo"/>

            <div v-if="importing">

            </div>

            <loading-indicator name="user.tumblr.import"/>


        </centered-card>
    </div>
</template>

<script>

    import MainNavigation from '../../layout/MainNavigation.vue';
    import CenteredCard from '../../layout/CenteredCard.vue';
    import LoadingIndicator from "../../ui/LoadingIndicator";
    import StepIndicator from '../../ui/StepIndicator';

    const storageDriver = localStorage;

    export default {
        name: '',
        data() {
            return {
                importing: false,
                tumblrAuthUrl: null,
                currentStep: 1,
                blogs: []
            }
        },
        computed:{
            blogList(){
                if(this.importing){
                    return this.blogs.filter((blog)=>blog.selected);
                } else {
                    return this.blogs;
                }
            }
        },
        mounted() {
            if(this.$route.query.oauth_verifier){
                let ov = this.$route.query.oauth_verifier;
                let ta = JSON.parse(storageDriver.getItem('tumblrAuth'));
                if(ta.token && ta.secret){
                    this.$api.tumblrVerifyAuth(ta.token, ta.secret, ov)
                        .then((res)=>{
                            this.$store.commit('user/tumblrAuth', {
                                token: res.data.token,
                                secret: res.data.secret
                            });
                            storageDriver.removeItem('tumblrAuth');
                            this.loadBlogs();
                            this.currentStep = 2;
                        })
                }
            } else {
                this.$api.tumblrGetAuth()
                    .then((res)=>{
                        let auth = {
                            token: res.data.token,
                            secret: res.data.secret
                        };
                        this.$store.commit('user/tumblrAuth', auth);
                        storageDriver.setItem('tumblrAuth', JSON.stringify(auth));
                        this.tumblrAuthUrl = res.data.url;
                    })
            }

        },
        methods: {
            loadBlogs(){
                let ta = this.$store.getters['user/tumblrAuth'];
                this.$api.tumblrUserInfo(ta.token, ta.secret)
                    .then((res)=>{
                        let blogs = [];
                        res.data.user.blogs.forEach((blog)=>{
                            blog.selected = false;
                            blog.importing = false;
                            blog.importDone = false;
                            blog.localBlog = '';
                            blog.error = '';
                            blog.info = '';
                            blog.importedPosts = 0;
                            blogs.push(blog);
                        });
                        this.blogs = blogs;
                    })
            },

            startImport(){
                this.importing = true;
                let selected = this.blogs.filter((blog)=>blog.selected);



                if(selected.length<1){
                    this.importing = false;
                    this.$bus.$emit('error', 'Please select at least one blog!')
                    return;
                }

                this.currentStep = 3;

                selected.forEach((b)=>{
                    b.info = 'waiting...';
                });

                //this.blogs = selected;
                let ta = this.$store.getters['user/tumblrAuth'];

                this.importNextBlog();

                /*this.$api.tumblrImportBlogs(
                    ta.token, ta.secret, selected
                ).then((res)=>{
                    console.log()
                })
                */
            },

            importNextBlog(){
                let nextBlog = this.blogs.find((blog) => blog.selected && !blog.importing && !blog.importDone );
                if(nextBlog){
                    nextBlog.importing = true;
                    nextBlog.info = 'importing...';
                    let ta = this.$store.getters['user/tumblrAuth'];
                    this.$api.tumblrSyncBlog(ta.token, ta.secret, nextBlog.name)
                        .then((res)=>{
                            nextBlog.importing = false;
                            nextBlog.importDone = true;
                            nextBlog.importedPosts = res.data.postCount;
                            nextBlog.info = 'Imported '+res.data.postCount+' Posts';
                            this.importNextBlog();
                        })
                        .catch((err)=>{
                            nextBlog.importing = false;
                            nextBlog.importDone = true;
                            nextBlog.error = err;
                            nextBlog.info = err;
                            this.importNextBlog();
                        });
                } else {
                    this.currentStep = 4;
                }
            },

            getBlogAvatar(blog){
                return 'https://api.tumblr.com/v2/blog/'+blog.name+'/avatar/96'
            }
        },
        components:{
            LoadingIndicator,
            MainNavigation,
            CenteredCard,
            StepIndicator
        }
    }
</script>

<style lang="sass" scoped>

    @import '../../../assets/sass/vars'

    .blog
        //padding: 1em
        border: 1px solid #ccc
        margin-bottom: .5em
        cursor: pointer
        transition: all .2s ease-in-out

        &:hover
            border-color: $colorPrimary

        &.selected
            border-color: $colorPrimary
            box-shadow: 0 0 3px $colorPrimary
            //color: #FFF


    .bloglist-enter-active, .bloglist-leave-active
        transform-origin: top
        transition: all .4s ease-out

    .bloglist-enter, .bloglist-leave-to
        transform: scaleY(0)
        opacity: 0

    .bloglist-move
        transition: transform .4s

    .bloglist-leave-active
        position: absolute
        width: 100%


</style>


// WEBPACK FOOTER //
// src/components/user/tumblr/SyncTublrPage.vue